import React from 'react';

import { Box } from '@mui/material';
import { ChatAssistant } from '@modules/chat';

const Chat = () => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 0,
        py: { xs: 0, md: 2 },
        px: { xs: 0, sm: 2 },
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 1000,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          maxHeight: {
            xs: 'calc(100dvh - 170px)',
            md: 'min(580px, calc(100dvh - 200px))',
          },
          borderRadius: { xs: 0, md: 2 },
          overflow: 'hidden',
          boxShadow: { xs: 'none', md: 2 },
        }}
      >
        <ChatAssistant />
      </Box>
    </Box>
  );
};

export default Chat;
